<template>
  <modal class="modalCG topModal" @before-open="iphoneModalsSet" @before-close="closingModal" name="modalLogin" height="auto" :adaptive="true" :scrollable="true">
    <div class="modal-box">
      <div class="modal-header">
        <h2>Anmelden</h2>
        <span class="close" @click.prevent="toggleModal">
          <icon name="close" scale="2"></icon>
        </span>
      </div>
      <div class="modal-body text-center">
        <form>
          <div class="form-field sized m-0">
            <label for="email">Email</label>
            <input
                type="text"
                id="email"
                placeholder="Email"
                v-model="user.email"
                name="email"
                v-validate="'required|email|max:255'"
                :class="{'error': errors.has('email') || !credentials }"
                data-vv-as="Email"
                @keyup.enter="login"
            >
            <span v-show="errors.has('email')" class="errorMsg">{{ errors.first('email') }}</span>
          </div>
          <div class="form-field sized mr-3">
            <label for="password">Passwort</label>
            <input
                type="password"
                id="password"
                placeholder="Passwort"
                v-model="user.password"
                name="password"
                v-validate="'required'"
                :class="{'error': errors.has('password') || !credentials }"
                data-vv-as="Passwort"
                @keyup.enter="login"
            >
            <span v-show="errors.has('password')" class="errorMsg">{{ errors.first('password') }}</span>
          </div>
        </form>
        <h4 class="text-cg-error text-left text-xs"
            v-if="!credentials">Wir haben Deinen Benutzernamen nicht gefunden oder Dein Passwort ist falsch - bitte probiere es erneut!</h4>
        <div class="flex flex-row flex-wrap justify-between sm:flex-col sm:justify-center sm:items-center">
          <div class="my-2x cursor-pointer"><a @click.prevent="toggleRegister">Noch nicht registriert?</a></div>
          <div class="my-2x cursor-pointer"><a @click.prevent="toggleResetPassword">Passwort vergessen?</a></div>
        </div>
      </div>
      <div class="modal-action" >
        <button class="btn green" @click.prevent="login">Anmelden</button>
      </div>
    </div>
  </modal>

</template>

<script>
  import { EventBus } from '@/assets/js/event-bus.js'
  import { mapGetters, mapActions } from 'vuex'
  import api from '@/assets/js/api.js'
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'

  export default {
    name: 'login',
    mounted () {
      EventBus.$on('toggleLoginModal', (cb) => {
        this.cb = cb
        this.toggleModal()
      })
      EventBus.$on('escKey', () => {
        this.clearModal()
        this.showLoginModal = false
        this.$modal.hide('modalLogin')
      })
    },
    beforeDestroy () {
      EventBus.$off('toggleLoginModal')
      EventBus.$off('escKey')
    },
    mixins: [helpers, formatting],
    data () {
      return {
        showLoginModal: false,
        user: {
          email: '',
          password: ''
        },
        saveToast: null,
        credentials: true,
        cb: null
      }
    },
    methods: {
      ...mapActions([
        'getAuthAccount'
      ]),
      closingModal () {
        this.showLoginModal = false
        this.iphoneModalsUnset()
      },
      closeModal (e) {
        if (e.target.className === this.$refs.modalbackround.className) {
          this.toggleModal()
        }
      },
      toggleModal () {
        this.clearModal()
        this.showLoginModal = !this.showLoginModal
        this.showLoginModal ? this.$modal.show('modalLogin') : this.$modal.hide('modalLogin')
      },
      clearModal () {
        this.credentials = true
        this.errors.clear()
        this.user.password = ''
        this.user.email = ''
      },
      toggleRegister () {
        this.toggleModal()
        EventBus.$emit('toggleRegisterModal')
      },
      toggleResetPassword () {
        this.toggleModal()
        EventBus.$emit('togglePasswordResetModal')
      },
      login () {
        this.credentials = true
        var vm = this
        if (!vm.saveToast) {
          vm.saveToast = vm.$toasted.info('Anmeldung...', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            icon: 'info'
          })
          api.login(vm.user).then(
            response => {
              vm.saveToast.goAway(100)
              vm.saveToast = null
              api._saveToken(response.access_token)
              vm.getAuthAccount({
                cb: () => {
                  if (vm.redirect.state) {
                    vm.$router.push({name: vm.redirect.name})
                    vm.$store.commit('AUTH_SET_REDIRECT', {state: false, name: '', params: {}})
                  }
                }
              })
              vm.toggleModal()
              vm.$toasted.success('Du bist jetzt angemeldet!', {
                theme: 'primary',
                position: 'top-right',
                duration: 10000,
                action: {
                  text: 'X',
                  class: 'toastBtn',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
                icon: 'check'
              })
              vm.cb && vm.cb()
            },
            error => {
              vm.saveToast.goAway(100)
              vm.saveToast = null
              console.log(error)
              vm.credentials = false
              vm.$toasted.error('Email oder Passwort falsch.', {
                theme: 'primary',
                position: 'top-right',
                duration: 10000,
                action: {
                  text: 'X',
                  class: 'toastBtn',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
                icon: 'close'
              })
            }
          )
        }
      }
    },
    computed: {
      ...mapGetters({
        redirect: 'auth_get_redirect'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modals/Login.vue